const Banner = ({heading,image}) => {
    const styles = {
      bannerContainer: {
        backgroundColor: '#e6f7ff',
        // backgroundImage:`url("https://cdn.pixabay.com/photo/2022/07/11/22/54/burst-7316184_1280.jpg")`,
        padding: '2rem',
        borderRadius: '15px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      },
      heading: {
        color: '#001f3f',
        transition: 'color 0.3s ease',
        fontFamily:"serif"
      },
      paragraph: {
      fontFamily:"serif",
        color: ' #c63b36',
        lineHeight: '1.5',
      },
      button: {
        padding: '0.8rem 1.5rem',
        backgroundColor: '#006a4f',
        color: '#fff',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
      },
      image: {
        width: '100%',
        borderRadius: '10px',
        transition: 'transform 0.5s ease',
      },
    };
  
    return (
      <div className="container mt-5">
        <style>
          {`
          
            .banner-image:hover {
              transform: scale(1.05);
            }
          `}
        </style>
  
        <div className="banner-container" style={styles.bannerContainer}>
          <div className="row align-items-center">
            {/* Text Section */}
            <div className="col-lg-6 col-md-12 text-center text-lg-start mb-4 mb-lg-0">
              <h1 className="banner-heading" style={styles.heading}>{heading}</h1>
      
              <h2 style={styles.paragraph} className="mt-4">
              A New Era at CoderMonk
            </h2>
             
            </div>
  
            {/* Image Section */}
            <div className="col-lg-6 col-md-12 text-center">
              <img
                className="banner-image"
                src={image}
                alt="Tech Banner"
                style={styles.image}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default Banner;
  